/** @format */

import React, { useMemo, memo } from 'react';
import { Select, Spin } from 'antd';
import { useOfficeUsers } from 'features/users/hooks/useUsers';

interface UsersDropdownProps {
  officeId: string;
  value?: string;
  onChange?: (userId: string) => void;
}

/**
 * Users Dropdown Component
 * Fetches users by office ID and displays agent names
 */
const UsersDropdown: React.FC<UsersDropdownProps> = ({ officeId, value, onChange }) => {
  // Create stable filter object
  const officeIds = useMemo(() => {
    if (!officeId || officeId.length === 0) return undefined;
    return [officeId];
  }, [officeId]);
  
  const { users, loading } = useOfficeUsers(officeIds);

  const options = useMemo(() => {
    if (!users || users.length === 0) return [];
    return users.map((user: any) => ({
      label: `${user.firstName} ${user.lastName}`,
      value: user._id,
    }));
  }, [users]);

  if (!officeId || officeId.length === 0) {
    return <span>No office selected</span>;
  }

  return (
    <Spin spinning={loading}>
      <Select
        placeholder='Select Agent'
        value={value || undefined}
        onChange={onChange}
        options={options}
        style={{ width: '100%' }}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
    </Spin>
  );
};

export default memo(UsersDropdown, (prevProps, nextProps) => {
  return (
    prevProps.officeId === nextProps.officeId &&
    prevProps.value === nextProps.value
  );
});
